import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const config = {
  apiKey: 'AIzaSyDlczdZE1BLSbE9gMo8BqHBy13Ff1Ngf0s',
  authDomain: 'basiclogin-f8d4e.firebaseapp.com',
  databaseURL: 'https://basiclogin-f8d4e.firebaseio.com',
  projectId: 'basiclogin-f8d4e',
  storageBucket: 'basiclogin-f8d4e.appspot.com',
  messagingSenderId: '266044215315',
  appId: '1:266044215315:web:58bc8017a7ae36472aefe6',
};
firebase.initializeApp(config);

firebase
  .firestore()
  .enablePersistence()
  .catch(function (err) {
    if (err.code === 'failed-precondition') {
      // Multiple tabs open, persistence can only be enabled
      // in one tab at a a time.
      // ...
    } else if (err.code === 'unimplemented') {
      // The current browser does not support all of the
      // features required to enable persistence
      // ...
    }
  });

export function signOutUser() {
  auth.signOut();
}

export function DoLogin(email, password) {
  auth.signInWithEmailAndPassword(email, password).catch((error) => {
    //setError('Error signing in with password and email!');
    console.error('Error signing in with password and email', error);
  });
}

export const db = firebase.firestore();
export const auth = firebase.auth();
